<template>
  <div
    v-if="!isH5"
    class="course-status"
    :class="{
      'h5-course-status': isH5,
      'electron-course-status': isElectron,
    }"
  >
    <div v-if="liveState === 1" class="living-tag">
      <img src="../../../assets/images/course-card/living.gif" alt="" />
      <span>直播中</span>
    </div>
    <!-- 试听 -->
    <div v-else-if="trialState === 1" class="can-trial-tag">
      <img src="../../../assets/images/course-card/play-icon.png" alt="" />
      <span>试听</span>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    liveState: {
      type: Number,
      default: null,
    },
    trialState: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      isElectron: window.isElectron,
    };
  },
};
</script>

<style lang="scss" scoped>
.course-status {
  position: absolute;
  top: 4px;
  right: 4px;
  .living-tag,
  .can-trial-tag {
    // position: absolute;
    height: 24px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 1;
  }
  .living-tag {
    width: 68px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    padding-right: 1px;
    img {
      width: 12px;
      height: 12px;
      margin-right: 2px;
    }
  }
  .can-trial-tag {
    width: 60px;
    img {
      width: 10px;
      height: 10px;
      margin-right: 4px;
    }
    background: rgba(34, 36, 38, 0.6);
  }
}
.course-status.electron-course-status {
  position: absolute;
  top: 5px;
  left: 6px;
  .living-tag,
  .can-trial-tag {
    // top: 5px;
    // left: 6px;
    height: 20px;
    font-size: 12px;
  }
  .living-tag {
    width: 60px;
    padding-right: 1px;
    img {
      width: 12px;
      height: 12px;
      margin-right: 2px;
    }
  }
  .can-trial-tag {
    width: 50px;
    img {
      width: 8px;
      height: 8px;
      margin-right: 3px;
    }
  }
}
</style>
